const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyActiveOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-90"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.03,
    y: 285.87,
    width: 126.42,
    height: 8.92,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.48,
    y: 285.87,
    width: 54.97,
    height: 8.92,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.03,
    y: 294.79,
    width: 18.68,
    height: 87.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.71 303.83 92.03 297.47 92.03 294.79 110.71 294.79 110.71 303.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.77,
    y: 294.79,
    width: 18.68,
    height: 87.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.48,
    y: 294.79,
    width: 18.68,
    height: 87.61,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.15 303.83 163.48 297.47 163.48 294.79 182.15 294.79 182.15 303.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.32,
    y: 294.79,
    width: 18.68,
    height: 87.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 87.17,
    width: 159.33,
    height: 135.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.33,
    y: 87.17,
    width: 1.78,
    height: 135.67,
    transform: "translate(462.44 310) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 81.33,
    width: 123.67,
    height: 147.33,
    transform: "translate(305.67 4.33) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,198.06c9-30,11.5-74.25,30.64-68.15s-5.93,71.53-5.93,71.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,199.55c-9.16-43.48-6.85-101.2-35.31-99.88s0,101.77,0,101.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.46,194.67H122.15a4.85,4.85,0,0,0-5,4.61c-1.27,28.7,3.43,58,12.18,86.59h47.71c8.75-28.64,13.45-57.89,12.18-86.59A4.8,4.8,0,0,0,184.46,194.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.69,
    y: 102.3,
    width: 3.51,
    height: 280.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.18,
    y: 102.3,
    width: 3.51,
    height: 280.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 102.3,
    width: 3.51,
    height: 280.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.29,
    y: 102.3,
    width: 3.51,
    height: 280.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 100.38,
    width: 110.89,
    height: 3.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 168.97,
    width: 110.89,
    height: 3.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 237.56,
    width: 110.89,
    height: 3.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 306.15,
    width: 110.89,
    height: 3.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.8,
    y: 374.74,
    width: 110.89,
    height: 3.83,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 100.38,
    width: 24.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 168.97,
    width: 24.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 237.56,
    width: 24.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 306.15,
    width: 24.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.8,
    y: 374.74,
    width: 24.89,
    height: 3.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.53,123.71v-5.4H329.2v5.4a6.39,6.39,0,0,1-6.38,6.39h0a6.39,6.39,0,0,0-6.39,6.38V169h38.88V136.48a6.39,6.39,0,0,0-6.39-6.38h0A6.39,6.39,0,0,1,342.53,123.71Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 215.26,
    width: 58.42,
    height: 22.31,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.12,
    y: 215.26,
    width: 10.17,
    height: 22.31,
    transform: "translate(750.41 452.82) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.12,
    y: 225.18,
    width: 10.17,
    height: 2.46,
    transform: "translate(750.41 452.82) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 225.18,
    width: 58.42,
    height: 2.46,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.84,
    y: 335.3,
    width: 45.63,
    height: 39.44,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.47,
    y: 335.3,
    width: 7.94,
    height: 39.44,
    transform: "translate(716.88 710.05) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.47,
    y: 352.85,
    width: 7.94,
    height: 4.35,
    transform: "translate(716.88 710.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.84,
    y: 352.85,
    width: 45.63,
    height: 4.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.47,
    y: 348.25,
    width: 7.94,
    height: 1.55,
    transform: "translate(716.88 698.05) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.84,
    y: 348.25,
    width: 45.63,
    height: 1.55,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 266.05,
    width: 8.26,
    height: 40.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.7,
    y: 280.34,
    width: 8.26,
    height: 11.52,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.97,
    y: 266.05,
    width: 28.1,
    height: 40.1,
    transform: "translate(668.03 572.21) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.39,
    y: 260.87,
    width: 9.33,
    height: 45.28,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.39,
    y: 275.26,
    width: 9.33,
    height: 6.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.39,
    y: 286.9,
    width: 9.33,
    height: 6.97,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.72,
    y: 260.87,
    width: 31.73,
    height: 45.28,
    transform: "translate(697.18 567.02) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.08,
    y: 266.05,
    width: 5.03,
    height: 40.1,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.94,
    y: 271.13,
    width: 3.3,
    height: 29.94,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.11,
    y: 266.05,
    width: 17.09,
    height: 40.1,
    transform: "translate(703.3 572.21) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.86,
    y: 263.94,
    width: 5.68,
    height: 42.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.86,
    y: 277.35,
    width: 5.68,
    height: 6.5,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.86,
    y: 288.21,
    width: 5.68,
    height: 6.5,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.54,
    y: 263.94,
    width: 19.3,
    height: 42.21,
    transform: "translate(732.38 570.09) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.16,
    cy: 202.82,
    r: 12.44,
    transform: "translate(-42.32 303.47) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.92,
    cy: 206.63,
    r: 8.62,
    transform: "translate(-28.46 60.16) rotate(-9.22)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-90"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-90",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.11,338.69H254.55a0,0,0,0,1,0,0V405a6.47,6.47,0,0,1-6.47,6.47H132.58a6.47,6.47,0,0,1-6.47-6.47V338.69A0,0,0,0,1,126.11,338.69Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,338.69H217l-11.18-14.31c-1.23-1.57-4.27-2.84-6.8-2.84H117.28c-2.52,0-3.58,1.27-2.35,2.84Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,338.69H217l-11.18-14.31c-1.23-1.57-4.27-2.84-6.8-2.84H117.28c-2.52,0-3.58,1.27-2.35,2.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.55,338.69H163.67l11.18-9.33c1.23-1,4.27-1.85,6.8-1.85h81.73c2.53,0,3.58.83,2.35,1.85Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.67,338.69h90.88a0,0,0,0,1,0,0V405a6.47,6.47,0,0,1-6.47,6.47H170.14a6.47,6.47,0,0,1-6.47-6.47V338.69A0,0,0,0,1,163.67,338.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.39 338.69 137.39 384.17 140.53 381.69 142.74 384.17 144.66 381.41 146.63 384.17 149.37 382.1 152.39 384.17 152.39 338.69 137.39 338.69",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-90"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 157.72,
    y1: 239.48,
    x2: 141.57,
    y2: 225.92,
    style: {
      fill: "none",
      stroke: "#D81212",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.09,
    y1: 246.51,
    x2: 161.17,
    y2: 242.37,
    style: {
      fill: "none",
      stroke: "#D81212",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.47,274.89l53.28-66.59-70.94-59.56-47,53.93-7,13.49a3.76,3.76,0,0,0,.47,5.49l64,53.74A5.3,5.3,0,0,0,214.47,274.89Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.93 225.78 170.26 238.13 173.35 238.8 174.4 241.66 176.45 241.78 177.4 244.23 179.91 244.96 181.84 248.03 189.51 235.68 177.93 225.78",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.43 206.35 217.65 259.65 149.78 202.67 196.81 148.74 265.43 206.35",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.43 206.35 217.65 259.65 237.43 261.11 284.47 207.18 265.43 206.35",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.43 206.35 217.65 259.65 237.43 261.11 284.47 207.18 265.43 206.35",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.78 147.9 129.99 201.21 149.78 202.67 196.81 148.74 177.78 147.9",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.78 147.9 129.99 201.21 149.78 202.67 196.81 148.74 177.78 147.9",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.72 222.76 265.43 206.35 196.81 148.74 188.03 169.9 250.72 222.76",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.78 202.67 196.81 148.74 188.03 169.9 154.91 206.98 149.78 202.67",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,106c.19.64,0,1.27-.42,1.39s-.91-.3-1.1-.94,0-1.27.42-1.4S281.82,105.36,282,106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.07,107.26a24,24,0,0,1-1.46,6.43,3.89,3.89,0,0,0,3.26-.33Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.33,101.73a.4.4,0,0,0,.18-.22.38.38,0,0,0-.24-.5,3.9,3.9,0,0,0-3.58.41.4.4,0,0,0,.48.63h0a3.12,3.12,0,0,1,2.84-.3A.4.4,0,0,0,283.33,101.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,110.28c.44,5.3,1.75,15,4.88,17.24,0,0-.74,6.37-12,8-12.34,1.82-6.8-5.26-6.8-5.26,6.49-2.6,5.58-7.57,3.72-12.09l4.76-5.46C300.63,110.69,304,107.57,304.24,110.28Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.15,130.11c1-.91-1-4.55-2.23-5.06-3.22-1.35-16.39,0-21.34,4.25a5.46,5.46,0,0,0-.39,4.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09,397.41a2.68,2.68,0,0,1-2.08.06.82.82,0,0,1-.27-.9.91.91,0,0,1,.46-.62c1.08-.63,3.75.2,3.86.24a.19.19,0,0,1,.14.16.2.2,0,0,1-.1.2A10.76,10.76,0,0,1,355.09,397.41Zm-1.46-1.22-.23.1a.54.54,0,0,0-.27.36c-.07.36.07.47.11.5.48.34,2.11-.15,3.24-.72A6.55,6.55,0,0,0,353.63,396.19Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.06,396.56a.17.17,0,0,1-.1,0c-1-.2-3.09-1.45-3.2-2.39a.64.64,0,0,1,.45-.68,1.08,1.08,0,0,1,.88,0c1.16.48,2.06,2.72,2.09,2.81a.18.18,0,0,1,0,.2A.15.15,0,0,1,357.06,396.56Zm-2.6-2.73a.16.16,0,0,0-.09,0c-.23.1-.22.22-.21.27.06.56,1.48,1.57,2.49,1.94-.3-.65-1-1.91-1.71-2.21A.67.67,0,0,0,354.46,393.83Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.48,408.15c-1.07,0-2.1-.15-2.45-.63a.74.74,0,0,1,0-.86,1,1,0,0,1,.62-.47c1.39-.37,4.31,1.29,4.43,1.36a.19.19,0,0,1-.06.36A14.14,14.14,0,0,1,296.48,408.15Zm-1.32-1.62a1.13,1.13,0,0,0-.38.05.63.63,0,0,0-.39.27c-.14.25-.09.37,0,.44.39.54,2.5.55,4,.33A8.88,8.88,0,0,0,295.16,406.53Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,407.92l-.08,0c-1-.45-3-2.26-2.85-3.2,0-.22.2-.5.74-.55a1.42,1.42,0,0,1,1.09.34c1.07.87,1.29,3.12,1.3,3.21a.18.18,0,0,1-.08.18A.19.19,0,0,1,299,407.92Zm-2-3.38h-.12c-.36,0-.38.18-.39.22-.09.57,1.27,2,2.29,2.61a4.57,4.57,0,0,0-1.1-2.58A1,1,0,0,0,297,404.54Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.18 407.72 299.83 407.72 299 388.4 307.35 388.4 308.18 407.72",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.83 394.53 359.14 397.18 351.16 378.97 358.85 376.32 366.83 394.53",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,395.27l9-2.75a.73.73,0,0,1,.85.34l3.75,6.6a1.23,1.23,0,0,1-.73,1.78c-3.15.91-4.72,1.19-8.66,2.4-2.43.74-8.55,3.06-12,3.75s-4.56-2.61-3.22-3.2c6-2.65,8.46-5.66,9.89-8A2.06,2.06,0,0,1,357.31,395.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.89,406.75H309a.74.74,0,0,1,.71.57l1.65,7.42a1.21,1.21,0,0,1-1.2,1.48c-3.29-.05-8-.25-12.17-.25-4.83,0-6.86.27-12.53.27-3.42,0-4.37-3.46-2.94-3.78,6.53-1.43,9.72-1.58,15.36-5.06A3.93,3.93,0,0,1,299.89,406.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.14,132.84c2.43,2.23,4.53,4.46,6.71,6.79s4.2,4.74,6.16,7.31a69.73,69.73,0,0,1,5.56,8.24,35.94,35.94,0,0,1,2.34,4.94c.17.47.34.92.48,1.43a15.56,15.56,0,0,1,.41,1.57l.17.83.12.92a9.65,9.65,0,0,1,0,2.54,10.61,10.61,0,0,1-1.72,4.44,14.75,14.75,0,0,1-2.3,2.65,26.68,26.68,0,0,1-4.56,3.33,59.23,59.23,0,0,1-9,4.19,108.45,108.45,0,0,1-18.18,5l-1.75-6c5.43-2.35,10.93-4.89,16-7.6a60.56,60.56,0,0,0,7.11-4.38,16,16,0,0,0,2.59-2.3,3.63,3.63,0,0,0,.59-.85c.08-.17,0-.15-.1.21-.07.67-.06.15-.22-.21-.05-.17-.14-.4-.23-.62s-.2-.47-.31-.71a31.64,31.64,0,0,0-1.81-3.17,75.58,75.58,0,0,0-5-6.61c-1.84-2.18-3.78-4.35-5.77-6.48s-4.08-4.28-6-6.26Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,180.07,303,182.45l5.06,8.32s4.65-1.92,5.68-5.87Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.82 185.4 302.92 192.26 308.01 190.78 302.95 182.45 299.82 185.4",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,135.1c-.75,8,16.17,20.38,16.17,20.38l16.29-11.15a34.28,34.28,0,0,0-12-12.75C316.82,125.6,306.64,125.16,305.7,135.1Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.7,135.1c-.75,8,16.17,20.38,16.17,20.38l16.29-11.15a34.28,34.28,0,0,0-12-12.75C316.82,125.6,306.64,125.16,305.7,135.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278,134.46s-7.31,11.22,10.05,71.4l44.14-6.52c-.62-6.1-8-32.71-8.25-61.8A10.4,10.4,0,0,0,313,127.23c-1.28.07-2.6.16-3.91.29a164.5,164.5,0,0,0-18.76,2.77A84.63,84.63,0,0,0,278,134.46Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278,134.46s-7.31,11.22,10.05,71.4l44.14-6.52c-.62-6.1-8-32.71-8.25-61.8A10.4,10.4,0,0,0,313,127.23c-1.28.07-2.6.16-3.91.29a164.5,164.5,0,0,0-18.76,2.77A84.63,84.63,0,0,0,278,134.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M276.92,153.8l.15-.17,10.38.92c1.58,6.7-4.2,15.84-7.25,20.08A195,195,0,0,1,276.92,153.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299 388.41 299.43 398.37 307.78 398.37 307.35 388.41 299 388.41",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.85 376.32 351.16 378.97 355.28 388.36 362.97 385.71 358.85 376.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.15,98.32c1.84,8.07,3.32,12.7.51,18-4.22,7.89-15.08,7.13-19.29-.23-3.79-6.63-6.17-18.71.67-24.15A11.3,11.3,0,0,1,303.15,98.32Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.94,106.23l-3.07,1.88.29-10.5A9.07,9.07,0,0,1,278.6,96c1.11-1.06,18.39-7.11,23.78-6.06.56-.23,1.24-1.27,1.24-1.27s.21,1.31-.7,1.81c.66-.13,2.31.19,2.77,1.16a3.61,3.61,0,0,0-2.29.13s6,.91,3.87,9.23c-2.39,9.17-1.6,14.44-1.6,14.44s-4.46,3.45-8.34,2.81C293.19,113.69,287.21,108.21,286.94,106.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,95.17c-4.87,0-6.62-2.38-7.87-4.38,3.5-.37,10.79-2.62,16.2-3s11.34.63,9.55,3S281.06,95.17,281.06,95.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.13,93c-4-.56-7.9-4.33-4.9-7.94,1.11,2.65,8.6,2.34,13.92,1.23,7-1.46,11.85.9,9.37,5.67C299.16,94.57,282.13,93,282.13,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.26,103.84a9.39,9.39,0,0,1-.26,6c-1,2.51-3.22,2-4.38-.17-1-2-1.76-5.63-.06-7.44S290.54,101.47,291.26,103.84Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.71,203.55s7.16,60.95,12.36,84.83c5.69,26.16,33.76,97.48,33.76,97.48l14-4.84s-18-53.7-22.78-90.27c-3.67-28.08-8.9-91.41-8.9-91.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.25,381.38c-.07,0,2.87,6,2.87,6l16.35-5.31-1.92-4.88Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.66,234.82c2.24,16.94,5.11,37,7.63,49.81C319,265,319.87,240.21,307.66,234.82Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.05,205.86s-5.94,57.26-5,82.7c.94,26.46,13.3,107.88,13.3,107.88h14.13s-2.6-79.88-2-105.86c.69-28.33,11.31-89.41,11.31-89.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.6,390.81c-.06,0,.8,5.86.8,5.86h17.19l.47-5.23Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.31,148.52c-1.56,2.48-3.14,4.71-4.78,7s-3.36,4.5-5.11,6.7a126.58,126.58,0,0,1-11.57,12.62c-1.12,1-2.15,2-3.36,2.91l-.88.71-.44.35c-.16.13-.23.2-.56.44a12.58,12.58,0,0,1-3.23,1.66,18.78,18.78,0,0,1-5.53,1,30.82,30.82,0,0,1-4.77-.21,60.07,60.07,0,0,1-16.75-4.74l1.73-6a110.14,110.14,0,0,0,15.42.74,30.51,30.51,0,0,0,3.4-.37,8.18,8.18,0,0,0,2.44-.76c.24-.13.37-.26.34-.29s.13-.13.22-.22l.34-.31.67-.63c.9-.8,1.75-1.77,2.63-2.65,1.73-1.86,3.45-3.77,5.08-5.8s3.28-4.07,4.88-6.17,3.15-4.23,4.71-6.36,3.08-4.37,4.52-6.44Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.12,145.87c3.36,11-16.15,23.19-16.15,23.19l-12.68-16.15a70.73,70.73,0,0,1,10.5-14.69C281.42,128.83,288.56,137.5,291.12,145.87Z",
    style: {
      fill: "#D81212"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.12,145.87c3.36,11-16.15,23.19-16.15,23.19l-12.68-16.15a70.73,70.73,0,0,1,10.5-14.69C281.42,128.83,288.56,137.5,291.12,145.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233,171.33l-10.27-1.88,1.08,8.88s5.34,3,9.21-1.69Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.77 171.45 220.99 177.86 223.79 178.33 222.71 169.45 218.77 171.45",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyActiveOrders);
export default __webpack_public_path__ + "static/media/empty-active-orders.c7102f6a9ac3e8b92a5afaae941ad6cc.svg";
export { ForwardRef as ReactComponent };